import styled from 'styled-components';
import {
  compose,
  flexbox, grid, layout, space, typography,
} from 'styled-system';
import { ExamCardBodyInfoItemContainerProps } from './ExamCardBodyInfoItem.types';

export const ItemContainer = styled.span<ExamCardBodyInfoItemContainerProps>`
  ${compose(space, grid, flexbox, layout, typography)}
`;
